export const TEXT = {
    CREATE_COLLECTION_PREVIEW_HEADER_TEXT: 'Create New Collection'
};